/* unplugin-vue-components disabled */import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import BaseEchart from '@/base-ui/echart';
export default /*#__PURE__*/_defineComponent({
  __name: 'pie-echart',
  props: {
    pieData: {},
    unit: {
      default: '吨'
    },
    fontSize: {
      default: 8
    },
    labelShow: {
      type: Boolean
    },
    customLabel: {
      type: Boolean,
      default: false
    },
    labelFormatter: {},
    customTooltip: {
      type: Boolean,
      default: false
    },
    tooltipFormatter: {},
    radius: {
      default: function _default() {
        return ['15%', '50%'];
      }
    },
    height: {
      default: '300px'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var options = computed(function () {
      var option = {
        tooltip: {
          trigger: 'item',
          enterable: false,
          formatter: function formatter() {
            return {};
          },
          position: ['5%', '10%']
        },
        // legend: {
        //   orient: 'horizontal'
        // },
        series: [{
          name: '',
          type: 'pie',
          startAngle: 180,
          radius: props.radius,
          data: props.pieData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          label: {
            show: props.labelShow,
            alignTo: 'edge',
            formatter: '{c}' + props.unit + ' \n{b}',
            minMargin: 5,
            edgeDistance: 10,
            lineHeight: 15,
            rich: {
              time: {
                fontSize: 10,
                color: '#999'
              }
            },
            fontSize: props.fontSize
          }
        }]
      };
      if (props.customLabel) {
        option.series.forEach(function (item) {
          item.label.formatter = props.labelFormatter;
        });
      }
      if (props.customTooltip) {
        option.tooltip.enterable = true;
        option.tooltip.formatter = props.tooltipFormatter;
      }
      return option;
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(_unref(BaseEchart), {
        options: _unref(options),
        height: _ctx.height
      }, null, 8, ["options", "height"]);
    };
  }
});